<template>
  <v-container v-if="quoteQuestions">
    <!-- <div style="display:hidden">{{feedback.categories}}</div> -->
    <v-alert :value="true" type="info" outline>
      If you are unsure about anything or need more explanation of the costs and
      charges detailed in the quotation do not hesitate to email us at
      <a href="mailto:sales@nbmlaw.co.uk">sales@nbmlaw.co.uk</a> or call us on
      <a href="tel:+441245357348">
        <span style="font-weight: bold">01245 357348</span> </a
      >.
    </v-alert>
    <v-form ref="form" v-model="valid" lazy-validation>
      <!-- <h1>{{quoteQuestions.heading}}</h1> -->
      <v-card v-for="category in quoteQuestions.categories" :key="category.id">
        <v-card-title class="subheading font-weight-bold">{{
          category.heading
        }}</v-card-title>
        <v-card-text>
          <v-layout wrap>
            <v-flex
              md6
              pa-1
              v-for="question in category.questions"
              :key="question.id"
            >
              <!-- <div>feedback value: {{feedback.categories[category.id][question.id]}}</div> -->
              <v-select
                v-if="question.options"
                v-model="feedback.categories[category.id][question.id]"
                :items="question.options"
                item-text="value"
                item-value="id"
                :label="question.body"
                :rules="[questionSelectRule]"
              >
                <template v-slot:append-outer v-if="question.description">
                  <Description :question="question" />
                </template>
              </v-select>
              <v-text-field
                type="number"
                v-if="!question.options"
                v-model="feedback.categories[category.id][question.id]"
                :label="question.body"
                :rules="[questionNumberRule]"
              >
                <template v-slot:append-outer v-if="question.description">
                  <Description :question="question" />
                </template>
              </v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
      <v-card>
        <v-card-title class="subheading font-weight-bold"
          >Please enter your details so we can send your quote direct to your
          mailbox</v-card-title
        >
        <v-card-text>
          <v-layout wrap>
            <v-flex md6 pa-1>
              <v-text-field
                v-model="feedback.instruct.name"
                label="Full name *"
                :rules="[nameRule]"
              />
            </v-flex>
            <v-flex md6 pa-1>
              <v-text-field
                v-model="feedback.instruct.email"
                label="Email address *"
                :rules="[emailRule]"
              />
            </v-flex>
            <v-flex md6 pa-1>
              <v-text-field
                v-model="feedback.instruct.telephone"
                label="Telephone"
              />
            </v-flex>
            <v-flex md6 pa-1>
              <v-text-field
                v-model="feedback.instruct.address"
                label="Address"
              />
            </v-flex>
            <v-flex md6 pa-1>
              <v-text-field
                v-model="feedback.instruct.note"
                label="Additional Information"
              />
            </v-flex>
            <v-flex md6 pa-1>
              <v-select
                v-model="feedback.instruct.referrerId"
                :items="referrers"
                item-text="name"
                item-value="id"
                label="Where did you hear about us? *"
                :rules="[referrerRule]"
              />
            </v-flex>
            <v-flex md12 pa-1>
              <v-checkbox
                v-model="feedback.instruct.gdpr"
                label="I consent to NBM Solicitors sending me a quote for Conveyancing services and to contact me to discuss it further and with any further marketing information which specifically relates to this *"
                :rules="[gdprRule]"
              />
              <a
                href="https://www.nbmlaw.co.uk/gdpr-general-data-protection-regulation.htm"
                target="_blank"
                >Privacy policy</a
              >
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
      <v-card>
        <v-card-title class="subheading font-weight-bold"
          >Promotion code</v-card-title
        >
        <v-card-text>
          <v-text-field
            v-model="promotionCode"
            label="If you have a promotion code, please enter it here"
            v-on:keyup="validatePromotion"
            :error-messages="promotionCodeErrors"
            :rules="promotionCodeRules"
          />
        </v-card-text>
      </v-card>
      <v-card>
        <v-card-text>
          <v-btn
            round
            color="primary"
            large
            @click="generateQuote"
            :disabled="clicked"
          >
            <v-icon>thumb_up</v-icon>Generate quote
          </v-btn>
          <v-alert :value="true" type="error" v-if="errorMessage">{{
            errorMessage
          }}</v-alert>
        </v-card-text>
      </v-card>
    </v-form>
  </v-container>
</template>

<script>
import emailValidator from "email-validator";
import nbmlaw from "@/apis/nbmlaw";
import Description from "@/components/Description";
import cookie from "@/components/cookie.js";
export default {
  name: "QuoteQuestions",
  components: {
    Description
  },
  mixins: [cookie],
  props: {
    quoteTypeId: null
  },
  data() {
    return {
      quoteQuestions: null,
      feedback: null,
      valid: false,
      questionSelectRule: (v) => !!v || "Selection is required",
      questionNumberRule: (v) => {
        if (!isNaN(parseFloat(v)) && v >= 0) return true;
        return "Number greater than or equal to 0";
      },
      nameRule: (v) => !!v || "Name is required",
      emailRule: (v) => {
        if (!v) {
          return "Email address is required";
        }
        return emailValidator.validate(v) || "Invalid e-mail.";
      },
      referrerRule: (v) => !!v || "Please choose from the list",
      gdprRule: (v) => !!v || "Please tick the box",
      promotionCode: null,
      promotionCodeErrors: [],
      promotionCodeRules: [],
      referrers: null,
      errorMessage: null,
      clicked: false
    };
  },
  methods: {
    async fetchQuoteQuestions() {
      const response = await nbmlaw.get(
        `/cors/open/sales/quoteTypes/${this.quoteTypeId}/quoteQuestions`
      );
      // console.log(response.data);
      this.quoteQuestions = response.data;
    },
    async fetchReferrers() {
      const response = await nbmlaw.get(
        `/cors/open/sales/whereDidYouHearAboutUs`
      );
      this.referrers = response.data;
    },
    async generateQuote() {
      if (this.$refs.form.validate() && this.promotionCodeErrors.length === 0) {
        this.clicked = true;
        const token = await this.$recaptcha("quoteQuestions");
        this.createQuote(token);
      }
    },
    async createQuote(token) {
      try {
        const response = await nbmlaw.post(
          `/cors/open/sales/quoteTypes/${this.quoteTypeId}/quotes`,
          this.feedback,
          {
            params: {
              token,
              salesUid: this.$cookies.get("salesUid"),
              promotionCode: this.promotionCode
            }
          }
        );
        // console.log(response.data);
        let quoteid = response.data;
        this.$refs.form.reset();
        this.$router.push({
          name: "quotation",
          params: {
            quoteId: quoteid,
            salesUid: this.$cookies.get("salesUid")
          }
        });
        this.errorMessage = null;
      } catch (err) {
        console.log(err);
        this.errorMessage = err;
        this.clicked = false;
      }
    },
    async validatePromotion() {
      if (this.promotionCode) {
        this.promotionCodeErrors = ["Checking promotion..."];
        try {
          const response = await nbmlaw.get(
            `/cors/open/sales/promotions/valid`,
            { params: { code: this.promotionCode } }
          );
          // console.log(response.data);
          if (response.data) {
            this.promotionCodeErrors = [];
          } else {
            this.promotionCodeErrors = ["That promotion could not be found"];
          }
        } catch (err) {
          console.log(err);
          this.promotionCodeErrors = [
            "There was an error checking the promotion"
          ];
        }
      } else {
        this.promotionCodeErrors = [];
      }
    }
  },
  watch: {
    quoteQuestions: {
      handler() {
        let categories = new Object();
        this.quoteQuestions.categories.forEach((category) => {
          let questionsMap = new Object();
          category.questions.forEach((question) => {
            if (question.defaultoptionid) {
              questionsMap[question.id] = question.defaultoptionid;
            } else {
              questionsMap[question.id] = question.defaultvalue;
            }
          });
          categories[category.id] = questionsMap;
        });
        this.feedback = {
          instruct: {
            proceed: "enquire",
            name: null,
            email: null,
            telephone: null,
            address: null,
            note: null,
            referrerId: null,
            gdpr: null
          },
          categories
        };
      }
    }
  },
  created() {
    this.fetchCookie();
    this.fetchQuoteQuestions();
    this.fetchReferrers();
  }
};
</script>

<style></style>